import axios from "axios";
import { IHttpRequest } from "./utils";

export const httpRequest = axios as IHttpRequest;
